<template>
    <div class="CompWallet" v-loading="loading">
        <iframe :src="url" frameborder="0" border="0" ref="iframeRef"></iframe>
    </div>
</template>
<script>
var httplinkUrl=""
if(location.host.indexOf("v5qy.test.baibaodun.cn")>-1){//测试
  httplinkUrl='http://attendsweb.test.baibaodun.cn'
}else{//正式
  httplinkUrl='http://paspweb.bcx.bcxin.com.cn'
}
export default {    
    data(){
        return{            
            loading: true,
            url:`${httplinkUrl}/finance/business-wallet?access_token=${localStorage.getItem('accessToken')}&userV5Token=1` //跳转sass的企业钱包页面
            //  url:`/static/signon/sass/index.html#/finance/business-wallet?access_token=${localStorage.getItem('accessToken')}&userV5Token=1` //跳转sass的企业钱包页面
        }
    },
    mounted() {
        const { iframeRef } = this.$refs;
        // IE和非IE浏览器，监听iframe加载事件不一样，需要兼容
        const that = this;
        if (iframeRef.attachEvent) {
            // IE
            iframeRef.attachEvent('onload', () => {
                that.stateChange();
            });
        } else {
            // 非IE
            iframeRef.onload = function () {
                that.stateChange();
            };
        }
    },
    methods: {
        stateChange() {
          this.loading = false;
        },
    },
}
</script>
<style lang="scss">
.CompWallet{
    iframe {
        display: block; /* iframes are inline by default */
        background: none;
        border: none; /* Reset default border */
        height: 100vh; /* Viewport-relative units */
        width: 100vw;
        padding-bottom:30px;
    }
}
</style>